import React from "react";
import { Link } from "react-router-dom";

import TinySlider from "tiny-slider-react";

import "../../../node_modules/tiny-slider/dist/tiny-slider.css";

// hook
import { useTranslation, Trans } from "react-i18next";

const settings = {
  lazyload: true,
  controls: false,
  mouseDrag: true,
  loop: true,
  rewind: true,
  autoplay: true,
  autoplayButtonOutput: false,
  autoplayTimeout: 4000,
  navPosition: "bottom",
  speed: 2000,
  gutter: 12,
  responsive: {
    1530: {
      items: 2,
    },
    992: {
      items: 2,
    },

    767: {
      items: 1,
    },

    320: {
      items: 1,
    },
  },
};
export default function CounselingTestimonial() {
  const { t, i18n } = useTranslation();

  const all_review = [
    {
      name: "Mother of a 4-year-old daughter",
      designation: "Manager",
      image: "/images/client/counseling_1.jpg",
      desc: "I never realized play therapy could make such a big difference! My daughter used to be so fearful and anxious, but now she’s much calmer. Sometimes, she even turns around and comforts me—it’s truly heartwarming.",
    },
    {
      name: "Father of a 5-year-old daughter",
      designation: "Manager",
      image: "/images/client/counseling_1.jpg",
      desc: "As a dad, I often found it hard to understand what my daughter was really thinking. Thanks to the advice and guidance from the play therapist, my wife and I learned how to support her better at home. Her mood and confidence have improved so much.",
    },
    {
      name: "Mother of a 3-year-old son",
      designation: "Manager",
      image: "/images/client/counseling_1.jpg",
      desc: "I’ve seen steady progress in my son since he started play therapy. Watching him grow and improve week after week has been wonderful—I honestly wish the sessions could go on longer!",
    },
    {
      name: "Father of a 7-year-old son",
      designation: "Manager",
      image: "/images/client/counseling_1.jpg",
      desc: "After my son was targeted at school, he held on to so much anger that we didn’t know how to help him. Thankfully, we met Miss Wong. Through play therapy, he found a safe way to express his feelings and heal. I’m so grateful for that support.",
    },
  ];

  const all_review_zh = [
    {
      name: "育有4歲女兒的媽媽",
      designation: "一般輔導",
      image: "/images/client/counseling_3.jpg",
      desc: "冇諗過遊戲治療個功效咁大！我個女直頭又好恐懼、焦慮，而家平靜咗好多，有時反而會安慰返我轉頭。",
    },
    {
      name: "育有5歲女兒的爸爸",
      designation: "一般輔導",
      image: "/images/client/counseling_3.jpg",
      desc: "有時作為爸爸都好難理解個女諗乜嘢，透過遊戲治療師過程裏面比嘅建議，喺生活裏面兩公婆調整返，阿女嘅狀態好咗好多。",
    },
    {
      name: "育有3歲兒子的媽媽",
      designation: "一般輔導",
      image: "/images/client/counseling_3.jpg",
      desc: "阿仔嘅情況一路見，一路持續進步，真係唔想咁快就完結服務。",
    },
    {
      name: "育有7歲兒子的爸爸",
      designation: "一般輔導",
      image: "/images/client/counseling_3.jpg",
      desc: "之前阿仔俾人喺學校針對，發生咗件事之後佢就一直好多憤怒嘅情緒，我都唔知點處理！好彩遇到黃姑娘，透過遊戲治療，阿仔搵到個位去釋放返件事。",
    },
  ];

  return (
    <section className="relative py-16" id="testi">
      <div className="container">
        <div className="grid grid-cols-1 text-center">
          <h3
            className={`mb-6 md:text-2xl text-xl md:leading-normal leading-normal
           ${i18n.resolvedLanguage === "zh" ? "font-reborn" : "font-semibold"}
          `}
          >
            {t("client.title")}
          </h3>
        </div>
        {i18n.resolvedLanguage === "zh" && (
          <div className="grid relative grid-cols-1 mt-8">
            <div className="tiny-three-item">
              <TinySlider settings={settings}>
                {all_review_zh.map((item, index) => (
                  <div className="tiny-slide" key={index}>
                    <div className="customer-testi">
                      <div className="content relative rounded shadow shadow-gray-200 dark:shadow-gray-800 m-1 p-6 bg-white dark:bg-slate-900">
                        <i className="mdi mdi-format-quote-open mdi-48px text-amber-500"></i>

                        <p className="text-slate-400 text-[18px] font-reborn">
                          {item.desc}
                        </p>

                        <p className="text-slate-400 text-[18px] font-reborn mt-3">
                          {item.name}
                        </p>
                        <ul className="list-none  text-amber-400">
                          <li className="inline">
                            <i className="mdi mdi-star"></i>
                          </li>
                          <li className="inline">
                            <i className="mdi mdi-star"></i>
                          </li>
                          <li className="inline">
                            <i className="mdi mdi-star"></i>
                          </li>
                          <li className="inline">
                            <i className="mdi mdi-star"></i>
                          </li>
                          <li className="inline">
                            <i className="mdi mdi-star"></i>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                ))}
              </TinySlider>
            </div>
          </div>
        )}

        {i18n.resolvedLanguage === "en" && (
          <div className="grid relative grid-cols-1 mt-8">
            <div className="tiny-three-item">
              <TinySlider settings={settings}>
                {all_review.map((item, index) => (
                  <div className="tiny-slide" key={index}>
                    <div className="customer-testi">
                      <div className="content relative rounded shadow shadow-gray-200 dark:shadow-gray-800 m-2 p-6 bg-white dark:bg-slate-900">
                        <i className="mdi mdi-format-quote-open mdi-48px text-amber-500"></i>
                        <p className="text-slate-400 text-[15px]">
                          {item.desc}
                        </p>
                        <p className="text-slate-400 text-[15px] font-reborn mt-3">
                          {item.name}
                        </p>
                        <ul className="list-none text-amber-400">
                          <li className="inline">
                            <i className="mdi mdi-star"></i>
                          </li>
                          <li className="inline">
                            <i className="mdi mdi-star"></i>
                          </li>
                          <li className="inline">
                            <i className="mdi mdi-star"></i>
                          </li>
                          <li className="inline">
                            <i className="mdi mdi-star"></i>
                          </li>
                          <li className="inline">
                            <i className="mdi mdi-star"></i>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                ))}
              </TinySlider>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
